import { z } from 'zod';
import { Group } from './groups.types';

export type ApiKey = {
  id: number;
  name: string;
  hashed_token: string;
  usercompany_id: number;
  user_id: number;
  created_at: number;
  expires_at: number;
  is_real_user: boolean;
};

export type CreatedApiKey = ApiKey & {
  token: string;
};

export type ApiKeyDetailed = ApiKey & {
  role: string;
  is_admin: boolean;
  permissions: string[];
  groups: Group[];
};

export type CreateApiKeyPayload = {
  name: string;
  role: string;
  is_admin: boolean;
  permissions: Record<string, boolean>;
  group_ids: number[];
};

export type UpdateApiKeyPayload = {
  role: string;
  is_admin: boolean;
  permissions: Record<string, boolean>;
  group_ids: number[];
};

export const LegacyTokenCount = z.object({
  count: z.number(),
});
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type LegacyTokenCount = z.infer<typeof LegacyTokenCount>;
